import React, { useState } from 'react';
import {
  Box, Button, Divider, Link, Typography,
} from '@mui/material';
import Screen from '../Screen';
import SelectBankAccount from '../SelectBankAccount';
import AddBankAccount from '../AddBankAccount';
import PlaidLink from '../PlaidLink';
import { currencyFormat } from '../../constants';
import useApplication from '../../resources/applications/read';
import useBankAccounts from '../../resources/bankAccounts/read';

const InstallmentAutoPay = () => {
  const { data: application } = useApplication();
  const { data: bankAccounts } = useBankAccounts();
  const [view, setView] = useState(null);

  if (view === 'BANK_FORM') {
    return <AddBankAccount onDone={() => setView(null)} />;
  }

  return (
    <Screen header="Connect your bank account.">
      <Box sx={{ mt: '-16px' }}>
        <Typography variant="body2" sx={{ mb: '8px' }}>
          Your monthly payment:
        </Typography>
        <Typography variant="h1" color="secondary">
          {currencyFormat.format(application.attributes.final_loan.data.attributes.payment)}
        </Typography>
      </Box>
      {bankAccounts.length > 0 && <SelectBankAccount />}
      <PlaidLink />
      <Typography variant="caption" textAlign="center" color="black">
        Powered by Plaid: By using this service you agree to
        {' '}
        <Link href="https://plaid.com/legal/" target="_blank" sx={{ textDecoration: 'none' }}>
          Plaid&apos;s privacy policy
        </Link>
        .
      </Typography>
      <Divider>OR</Divider>
      <Button onClick={() => setView('BANK_FORM')} variant="text" fullWidth>
        Enter Bank Account Manually
      </Button>
    </Screen>
  );
};

export default InstallmentAutoPay;
